// ======================================================================
// File Name       : ServiceNoticeRegisterContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import moment from 'moment';
import { Form, Col, Button } from 'react-bootstrap';
import Header from '../../components/Header';
import * as ServiceAction from '../../actions/ServiceAction';
import * as GroupAction from '../../actions/GroupAction';
import ServiceNoticeRegisterInfo from '../../components/service/serviceNotification/ServiceNoticeRegisterInfo';
import ServiceNoticeRegisterUserList from '../../components/service/serviceNotification/ServiceNoticeRegisterUserList';
import {
  SERVICE_NOTIFICATION_LIST,
  SERVICE_NOTIFICATION_DETAIL,
} from '../../constants/PathConstants';
import {
  RETURN_MAX_NUM,
  SELECT_TARGET_DATA,
  DEFAULT_DATE_FORMAT_SERVER,
  DEFAULT_DATE_SHORT_FORMAT_SERVER,
} from '../../constants/index';
import { SERVICE_USER_TYPE, RELEASE_TARGET } from '../../constants/ServiceConstant';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as ModalIds from '../../constants/ModalIds';
import * as ModalAction from '../../actions/ModalAction';
import ModalConductor from '../../components/modal/ModalConductor';
import { hasProperty, parseDateForDetail, isSuperUser } from '../../utils/index';
import * as userActions from '../../actions/UserAction';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ServiceNoticeRegisterContainer extends React.Component {
  constructor(props) {
    super(props);
    this.registerServiceNotice = this.registerServiceNotice.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.showSelectedGroupDialog = this.showSelectedGroupDialog.bind(this);
    this.showSearchUserDialog = this.showSearchUserDialog.bind(this);
    this.removeUserFromList = this.removeUserFromList.bind(this);
    this.handleChangeUserType = this.handleChangeUserType.bind(this);
    this.radioChange = this.radioChange.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(ServiceAction.resetEdittingUsers());
  }

  componentWillUnmount() {
    this.props.dispatch(GroupAction.removeSelectedGroupIds());
  }

  registerServiceNotice() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SERVICE_NOTICE_CONFIRM_DIALOG));
  }

  hideModal() {
    this.props.dispatch(ModalAction.hideModal());
  }

  showSelectedGroupDialog() {
    const { dispatch } = this.props;
    dispatch(GroupAction.fetchGroupStructure()).then(() => {
      dispatch(ModalAction.openModal(ModalIds.SELECT_GROUP_MODAL));
    });
  }

  showSearchUserDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SERVICE_USER_DIALOG));
  }

  removeUserFromList(userSecernId) {
    this.props.dispatch(ServiceAction.removeUserFromList(userSecernId));
  }

  handleChangeUserType() {
    const { dispatch } = this.props;
    this.props.dispatch(change('serviceNoticeRegisterForm', 'edittingUserList', {}));
    dispatch(ServiceAction.resetEdittingUsers());
  }
  radioChange(event, newValue, previousValue) {
    const { formValues } = this.props;
    if (formValues && Object.keys(formValues).length) {
      const nameTarget = event.target.name;
      if (hasProperty(formValues, nameTarget)) {
        const newFormValue = { ...formValues };
        let publicDateFromTemp = '';
        let publicDateToTemp = '';
        if (hasProperty(formValues, 'publicDateFrom')) {
          publicDateFromTemp = parseDateForDetail(formValues.publicDateFrom, 'YYYY/MM/DD', '');
        }
        if (hasProperty(formValues, 'publicDateTo')) {
          publicDateToTemp = parseDateForDetail(formValues.publicDateTo, 'YYYY/MM/DD', '');
        }
        if (newValue === 1 && previousValue === 0 && publicDateFromTemp == '' && publicDateToTemp == '') {
          // Step 9.3.0 START
          newFormValue.publicDateFrom = moment();
          newFormValue.publicDateTo = moment().add(1, 'month');
          // Step 9.3.0 END
        } else if (publicDateFromTemp != '' && publicDateToTemp != '') {
          newFormValue.publicDateFrom = publicDateFromTemp;
          newFormValue.publicDateTo = publicDateToTemp;
        }
        newFormValue.releasePeriod = newValue;
        this.props.dispatch(change('serviceNoticeRegisterForm', nameTarget, newFormValue));
        this.props.dispatch(change('serviceNoticeRegisterForm', 'publicDateFrom', newFormValue.publicDateFrom));
        this.props.dispatch(change('serviceNoticeRegisterForm', 'publicDateTo', newFormValue.publicDateTo));
      }
    }
  }

  render() {
    const { formValues, edittingUsers } = this.props;
    let userType = SERVICE_USER_TYPE.USAGE_SCREEN;
    let releaseTarget = 0;
    if (formValues) {
      userType = formValues.userType;
      releaseTarget = formValues.releaseTarget;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SERVICE_NOTIFICATION_LIST}
          text="お知らせ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="サービス向けお知らせ情報の新規登録" />
        <p>登録する項目を指定してください</p>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.registerServiceNotice();
          }}
          className="margin-top-10">
          <ServiceNoticeRegisterInfo
            {...formValues}
            showSelectedGroupDialog={this.showSelectedGroupDialog}
            showSearchUserDialog={this.showSearchUserDialog}
            handleChangeUserType={this.handleChangeUserType}
            radioChange={this.radioChange}
          />
          {releaseTarget === 1 && (
            <ServiceNoticeRegisterUserList
              edittingUsers={edittingUsers}
              removeUserFromList={this.removeUserFromList}
            />
          )}
          <Form.Group className="margin-top-20 text-center col-sm-12">
            <Button
              variant="primary"
              className="btn-96"
              type="submit"
              onClick={this.props.handleSubmit(this.registerServiceNotice)}
            >
              OK
            </Button>
          </Form.Group>
          <ModalConductor
            formKey="serviceNoticeRegisterForm"
            userType={userType}
            history={this.props.history}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceNoticeRegisterForm } = state.form;
  const { serviceNotice, serviceNotiRecordNum } = state.service;
  const { authedUser } = state.authed;
  let initial = {
    releasePeriod: 0,
    userType: SERVICE_USER_TYPE.USAGE_SCREEN,
    releaseTarget: RELEASE_TARGET.OVER_ALL,
    publicDateFrom: '',
    publicDateTo: '',
  };
  if (serviceNoticeRegisterForm) {
    initial = serviceNoticeRegisterForm.initial;
    if (serviceNoticeRegisterForm.values) {
      initial = serviceNoticeRegisterForm.values;
    }
  }
  const { edittingUsers } = state.service;
  const edittingUserList = {};
  if (edittingUsers && edittingUsers.allSecernIds) {
    const length = edittingUsers.allSecernIds.length;
    for (let i = 0; i < length; i++) {
      const userSecernId = edittingUsers.allSecernIds[i];
      edittingUserList[userSecernId] = true;
    }
  }
  const initialValues = {
    ...initial,
    ...{ edittingUserList },
  };
  return {
    serviceNoticeRegisterForm,
    serviceNotiRecordNum,
    serviceNotice,
    edittingUsers,
    invalid: isInvalid('serviceNoticeRegisterForm')(state),
    formValues: getFormValues('serviceNoticeRegisterForm')(state),
    initialValues,
    authedUser,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'serviceNoticeRegisterForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(ServiceNoticeRegisterContainer),
);
